import { layout } from '@prisjakt/ui-base';

export const getHeaderHeight = isMobile =>
  isMobile
    ? layout.headerHeight.mobile.value
    : layout.headerHeight.desktop.value;

export const getScrollLinkOffset = () => {
  const isMobile = window.innerWidth < 640;
  const extraWhitespace = 20;

  return (
    getHeaderHeight(isMobile) +
    layout.stickyNavigationHeight.value +
    extraWhitespace
  );
};
